import React, { useEffect, useState } from "react";
import localeText from "../../../../locale";
import Categories from "./Categories/Categories";
import Products from "./Products/Products";
import BanggoodService from "../../../../service/BanggoodService";
import { Button } from "primereact/button";
import { render } from "@fullcalendar/core";
import { set } from "@cloudinary/url-gen/actions/variable";
import categoriesDict from "./Categories/categoriesDict";
import Loading from "../../../../components/Loading/Loading";
import img from "../../../../assets/static/banggood.png";
import { Accordion, AccordionTab } from "primereact/accordion";
import { InputText } from "primereact/inputtext";
import { cat } from "@cloudinary/url-gen/qualifiers/focusOn";
import Product from "./Products/Product";
import { Chip } from "primereact/chip";

const Dropshipping = (props) => {
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState();
  const [activeCat, setActiveCat] = useState(null);
  const [totalProducts, setTotalProducts] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [page, setPage] = useState(1);

  const IsCatActive = () => {
    if (activeCat) {
      return <Chip label={activeCat.cat_name} removable onRemove={clearCategory} />;
    }
  };
  const fetchProducts = async () => {
    try {
      if (loading) {
        return;
      }
      setLoading(true);
      const banggoodService = new BanggoodService();
      const res = await banggoodService.getProductList(
        { lang: "en", cat_id: category?.cat_id || "", page: page },
        localStorage.getItem("__extraconomy_token")
      );
      setProducts(res.products);
      setTotalProducts(res.totalProducts);
      setCurrentPage(res.page);

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const selectCategory = (data) => {
    setActiveCat(data);
    setActiveIndex(-1);
    setCategory(data);
  };

  const clearCategory = () => {
    setCategory(null);
  };

  const onPageChange = async (event) => {
    setPage(event);
  };

  useEffect(() => {
    fetchProducts();
  }, [category, page]);

  useEffect(() => {
    let cat_list = [];
    for (let key of Object.keys(categoriesDict)) {
      cat_list.push(categoriesDict[key]);
    }

    setCategories(cat_list);
  }, []);

  return (
    <>
      <div className="flex justify-content-between align-items-center mb-2 gap-2">
        <div className="flex align-items-center font-medium lg:text-2xl md:text-2xl text-1xl line-height-2 mt-2 text-gray-600">
          <img className="" style={{ width: "200px" }} src={img} alt="" />
          <div>DropShipping</div>
        </div>
      </div>
      <Accordion
        className="mb-2"
        activeIndex={activeIndex}
        onTabChange={(e) => setActiveIndex(e.index)}
      >
        <AccordionTab header="Categorias">
          <div className="flex flex-row flex-wrap gap-2 mb-3">
            {categories.map((cat) => {
              return (
                <Button
                  key={cat.cat_id}
                  size="small"
                  label={cat.cat_name}
                  severity="secondary"
                  rounded
                  onClick={() => selectCategory(cat)}
                />
              );
            })}
          </div>
        </AccordionTab>
      </Accordion>
      <div className="mb-2">
        <IsCatActive />
      </div>

      <div>
        {loading ? (
          <Loading classNameIcon={"text-md"} disableMargin />
        ) : (
          <Products
            onPageChange={onPageChange}
            currentPage={currentPage}
            totalProducts={totalProducts}
            products={products}
          />
        )}
      </div>
    </>
  );
};

export default Dropshipping;
